import "./TwitchLoginModal.css";

export default function TwitchLoginModal() {
    // This redirects the user to the twitch auth flow on the NodeJS server.
    // It's important to send the current location as redirect_uri so the server
    // is then able to redirect the user back to this application.
    //
    // This MUST remain a redirect to be compliant with Twitch's OAuth2 requirements
    const handleLogin = async () => {
        const redirectAfterLogin = encodeURIComponent(window.location.href);

        window.location.href = `${
            import.meta.env.VITE_SERVER_URL
        }/api/auth/twitch?redirect_uri=${redirectAfterLogin}`;
    };

    // The login modal is very simple, it just asks the user to log in with twitch.
    return (
        <div className="twitch-login-modal-screen">
            <div className="twitch-login-modal">
                <h2 className="text-xl mb-4">Please log in with Twitch</h2>
                <button
                    onClick={() => {
                        handleLogin();
                    }}
                    className="twitch-login-button "
                >
                    Login with Twitch
                </button>
            </div>
        </div>
    );
}
